// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HeaderPrint header{padding:5px 10px}.HeaderPrint .print-logo{background-color:#fff;border-radius:11px;padding:5px 10px;width:200px}.HeaderPrint .print-logo img{width:100%}.HeaderPrint{display:none}@media print{.HeaderPrint{display:block}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
